import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { VerticalCatalogEntry } from '../lib/verticals';
import { useVerticalCatalog } from './useVerticalCatalog';

/**
 * The vertical whose pages the reader is on: the catalogue entry with the
 * longest `route_prefix` the path starts with, and ONLY among the verticals the
 * company has (a positive guard). The Header prints its name under the company.
 *
 * Fleet, Drivers and Trip Inspections live under /trucking and serve a
 * surface-rentals tenant too (#815). Matched on the path alone, a rentals-only
 * tenant read "Trucking" under its name on those pages, for a vertical it does
 * not have (2026-10-15). Now nothing is printed there.
 */
export function useActiveVertical(): VerticalCatalogEntry | null {
  const { pathname } = useLocation();
  const { hasVertical } = useAuth();

  const { data: catalog } = useVerticalCatalog();
  if (!catalog || catalog.length === 0) return null;

  // Match the longest route_prefix that pathname starts with
  let best: VerticalCatalogEntry | null = null;
  for (const entry of catalog) {
    if (!hasVertical(entry.key)) continue;
    const prefix = entry.route_prefix;
    if (
      pathname === prefix ||
      pathname.startsWith(prefix + '/')
    ) {
      if (!best || prefix.length > best.route_prefix.length) {
        best = entry;
      }
    }
  }

  return best;
}
